import React from 'react';
import { Spin } from 'antd';

function PageLoader() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '300px',
      }}
    >
      <Spin size="large" />
    </div>
  );
}

export default PageLoader;
